import { createFileRoute, Outlet } from "@tanstack/react-router";

import { requireSection } from "@/shared/auth/access";

/** The orders section: the board, an order's page, the new-order page. One guard for all. */
export const Route = createFileRoute("/_app/orders")({
  beforeLoad: ({ context }) => {
    requireSection(context.role, "orders");
  },
  component: Outlet,
});
